export const IsEmptyValue = (res) => {
    if (typeof res !== 'object') {
        return true;
    }
    if (Array.isArray(res) && !res.length) {
        return true;
    }
    return !res;
}
